
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Feature extends Vue {
    width = 'w-8 sm:w-16';
    height = 'h-8 sm:h-16';
}
